import AuthAxios from 'utils/authAxios';

import { useQuery, useMutation } from 'react-query';
import { dataApiUrl } from 'utils/url';

const DATA_API_URL = dataApiUrl();
const ADMIN_MEMBERSHIP_PERKS_URL = `${DATA_API_URL}/admin/membership-events`;

export function useGetMembershipEvents(params, options) {
  return useQuery(
    ['getMembershipEvents', params.page_index, params.page_size],
    () => AuthAxios.get(`${ADMIN_MEMBERSHIP_PERKS_URL}`, { params: { ...params } }),
    {
      select: res => res?.data?.data,
      ...options,
    }
  );
}

export function useGetMembershipEvent(id) {
  return useQuery(['getMembershipEvent', id], () => AuthAxios.get(`${ADMIN_MEMBERSHIP_PERKS_URL}/${id}`), {
    select: res => res?.data?.data,
  });
}

export function useUpdateMembershipEvent(options) {
  return useMutation(_body => {
    const { id, ...body } = _body;
    return AuthAxios.patch(`${ADMIN_MEMBERSHIP_PERKS_URL}/${id}`, body);
  }, options);
}

export function useDeleteMembershipEvent(options) {
  return useMutation(id => AuthAxios.delete(`${ADMIN_MEMBERSHIP_PERKS_URL}/${id}`), options);
}
